import React, { useEffect, useState } from 'react';
import { Formik, useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import { useFirstMountState } from 'react-use';
import cc from 'classcat';
import { useShipsSearchStore } from '../../../../../providers/RootStoreProvider';
import { ShipFilterCheckboxes } from '../ShipFilterCheckboxes';
import { ShipCardList } from '../ShipCardList';
import styles from './shipDesktopResult.module.sass';
import { EmptySearch } from '../../../../SearchCruises/EmptySearch';
import { ShowMore } from '../ShowMore';
import { Badge } from '../../../../Badge';
import { SkeletonCover } from '../../../../Skeleton/SkeletonCover';
import { SortPopup } from '../../../../SortPopup';
import { sortShips } from '../../../../../resources/sortShips';
import { Button } from '../../../../Button';
import { yandexDataLayer } from '../../../../../lib/yandexDataLayer';

const AutoSubmitForm = observer(() => {
  const store = useShipsSearchStore();
  const setBottomFilters = filters => store.setBottomFilters(filters);
  // const clearFilters = () => store.clearFilters();
  const { values, submitForm } = useFormikContext();

  const isFirstMount = useFirstMountState();

  useEffect(() => {
    if (!isFirstMount) {
      setBottomFilters(values);
      submitForm();
    }
  }, [values, submitForm]);

  return null;
});

const COUNT_SHIPS = 10;

export const ShipDesktopResult = observer(({ liners, isMobile }) => {
  const store = useShipsSearchStore();

  const {
    isLoading,
    filterClasses,
    filterServices,
    filteredShips,
    shipsList,
    filters,
  } = store;

  // const getList = () => store.getList();
  const { setParamsFilters } = store;
  const clearFilters = () => store.clearFilters();
  // const setExtraShips = params => store.setExtraShips(params);
  // const setPage = () => store.setPage();
  const [isTypeShipOpen, setTypeShipOpen] = useState(false);
  const [countShips, setCountShips] = useState(COUNT_SHIPS);

  const showMore = () => {
    setCountShips(countShips + COUNT_SHIPS);
  };

  useEffect(() => {
    store.getInitialData();
  }, []);

  const ships = filteredShips.slice(0, countShips);

  return (
    <Formik
      initialValues={{
        filterClasses: [],
        filterServices: [],
        sort: {
          sort_mode: sortShips[0].mode,
          sort_direction: sortShips[0].type,
        },
      }}
      onSubmit={async values => {
        setParamsFilters(values);
      }}
    >
      {({ values, setFieldValue }) => {
        const services = filterServices
          .map(service => ({
            ...service,
            count: shipsList.filter(ship =>
              ship.services?.some(service1 => service1.value === service.value),
            ).length,
          }))
          .slice(0, isTypeShipOpen ? filterServices.length : 5);

        return (
          <>
            <AutoSubmitForm />
            <div className={styles.header}>
              {!store.useFirstLoad ? (
                <div className={styles.total}>
                  <span>{liners ? 'Всего лайнеров' : 'Всего теплоходов'}:</span>
                  <Badge view="info" size="smUltra">
                    {filteredShips.length}
                  </Badge>
                </div>
              ) : (
                <div>
                  <SkeletonCover width={200} height={30} />
                </div>
              )}
              <SortPopup id="sort" sorts={sortShips} active={values.sort} />
            </div>

            <div className={styles.wrapper}>
              {/* <div> */}
              <div
                className={cc([
                  styles.sidebar,
                  { [styles.sidebarOpen]: isTypeShipOpen },
                ])}
              >
                <div className={styles.sidebarTop}>
                  <div className={styles.sidebarTitle}>Фильтр</div>
                  <Button
                    view="text"
                    onClick={() => {
                      clearFilters();
                      setFieldValue('filterClasses', []);
                      setFieldValue('filterServices', []);
                    }}
                  >
                    Очистить всё
                  </Button>
                </div>
                <ShipFilterCheckboxes
                  name="filterClasses"
                  title={liners ? 'Лайнеров' : 'Теплоход'}
                  isLoading={isLoading}
                  items={filterClasses.map(classItem => ({
                    ...classItem,
                    count: shipsList.filter(
                      ship => ship.class.value === classItem.value,
                    ).length,
                  }))}
                  ships={shipsList.map(ship => ship.class)}
                />
                <ShipFilterCheckboxes
                  name="filterServices"
                  title={'Услуги на борту'}
                  isLoading={isLoading}
                  items={services}
                  onShowMore={
                    filterServices.length <= 5
                      ? undefined
                      : () =>
                          setTypeShipOpen(
                            services.length !== filterServices.length,
                          )
                  }
                  isOpen={isTypeShipOpen}
                />
              </div>
              {/* </div> */}
              <div className={styles.list}>
                {ships?.length === 0 && !isLoading ? (
                  <EmptySearch />
                ) : (
                  <div>
                    <ShipCardList
                      isLoading={isLoading}
                      cruises={ships}
                      type={filters?.type}
                      isMobile={isMobile}
                    />
                    <ShowMore
                      length={filteredShips?.length}
                      amount={countShips}
                      setPage={showMore}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        );
      }}
    </Formik>
  );
});
